<script lang="ts">
  /**
   * GameObject - Individual emoji object that moves across the screen
   * Can be collected by the player
   */

  import { fade, scale } from 'svelte/transition';
  import { cubicOut } from 'svelte/easing';

  // Props
  interface Props {
    emoji: string;
    name: string;
    x: number;
    y: number;
    size?: number;
    showGlow?: boolean;
  }

  let {
    emoji,
    name,
    x,
    y,
    size = 60,
    showGlow = false
  }: Props = $props();
</script>

<div
  class="game-object"
  class:glow={showGlow}
  style="
    left: {x}px;
    top: {y}px;
    width: {size}px;
    height: {size}px;
  "
  role="img"
  aria-label={name}
  transition:scale={{
    duration: 400,
    easing: cubicOut,
    start: 0
  }}
>
  <span class="emoji">{emoji}</span>
</div>

<style>
  .game-object {
    position: absolute;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: filter 0.2s ease;
    z-index: 5;
    animation: float 3s ease-in-out infinite;
  }

  .emoji {
    font-size: 48px;
    user-select: none;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
  }

  /* Gentle floating animation */
  @keyframes float {
    0%, 100% {
      transform: translate(-50%, -50%) translateY(0) rotate(0deg);
    }
    50% {
      transform: translate(-50%, -50%) translateY(-10px) rotate(5deg);
    }
  }

  /* Pre-collision glow effect */
  .glow {
    animation: float 3s ease-in-out infinite, glowPulse 1s ease-in-out infinite;
  }

  @keyframes glowPulse {
    0%, 100% {
      filter: drop-shadow(0 0 8px rgba(252, 211, 77, 0.6));
    }
    50% {
      filter: drop-shadow(0 0 16px rgba(252, 211, 77, 0.9));
    }
  }

  /* Responsive sizing */
  @media (max-width: 767px) {
    .emoji {
      font-size: 40px;
    }
  }
</style>
